import { render, staticRenderFns } from "./activity-info.vue?vue&type=template&id=5e22adb0&scoped=true&"
import script from "./activity-info.vue?vue&type=script&lang=js&"
export * from "./activity-info.vue?vue&type=script&lang=js&"
import style0 from "./activity-info.vue?vue&type=style&index=0&id=5e22adb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22adb0",
  null
  
)

export default component.exports